import enLocale from 'element-ui/lib/locale/lang/en'

export default {
  message: {
    greeting: 'hello, {name}'
  },
  ...enLocale
}
